import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'

type Props = {
  label: string
  required: boolean
  name: string
  density: DensityType
  disabled: boolean
}

export default function WebhookTypeSelect(props: Props) {
  const { required, name, disabled, ...rest } = props
  const { initialOption, isSubmitting, showError, helperText, ...restUseData } =
    useData({ required, name })
  const { handleChange } = useHandlers()

  return (
    <Box mt="32px" mb="32px">
      <Select<string>
        {...restUseData}
        {...rest}
        disabled={isSubmitting || disabled}
        required={required}
        error={showError}
        disableClearOnBlur
        onChange={handleChange}
        value={initialOption}
        optionMode={'normal'}
        size="medium"
        textFieldProps={{
          size: 'medium',
        }}
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  )
}
